import React from "react";

function CryptoLoanPayTime() {
    return (
        <div className="col">
            <div className="hor-timeline-steps">
                <div className="hor-timeline-step">
                    <div className="timeline-content">
                        <div className="inner-circle"></div>
                        <p className="h6 mt-3 text-muted mb-0 mb-lg-0">Set Your Payment </p>
                    </div>
                </div>
                <div className="hor-timeline-step">
                    <div className="timeline-content">
                        <div className="inner-circle"></div>
                        <p className="h6 mt-3 text-muted mb-0 mb-lg-0">Fast Payments</p>
                    </div>
                </div>
                <div className="hor-timeline-step">
                    <div className="timeline-content">
                        <div className="inner-circle"></div>
                        <p className="h6 mt-3 text-muted mb-0 mb-lg-0">With Cryptoon Pay</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CryptoLoanPayTime;